import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag använda personal utan anställningsavtal?";
const SHORT_ANSWER = "Nej. Personal som serverar alkohol måste vara anställd eller inhyrd från godkänd bemanningsfirma. Svart arbetskraft är grund för återkallat tillstånd.";

export const Route = createFileRoute("/fraga/vad-galler-for-personal-utan-anstallningsavtal")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag använda personal utan anställningsavtal" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Vid samordnad tillsyn med Skatteverket är detta en av de hårdast bedömda punkterna. Lönerapportering och försäkring ska kunna styrkas."}
      source={{ label: "Skatteverket – Personlig och ekonomisk lämplighet", href: "https://www.skatteverket.se/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Arbetskraft och alkoholservering" }}
      related={[{"to": "/fraga/vad-galler-for-festival-och-utomhus", "label": "Vad gäller för alkoholservering på festival eller utomhus?"}, {"to": "/fraga/behover-mojligheten-kommunens-godkannande-i-forvag", "label": "Måste evenemangsplats godkännas i förväg?"}, {"to": "/fraga/far-jag-neka-en-gast-tilltrade", "label": "Får jag neka en gäst tillträde till restaurangen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag använda personal utan anställningsavtal?" },
      { name: "description", content: "Nej. Personal som serverar alkohol måste vara anställd eller inhyrd från godkänd bemanningsfirma. Svart arbetskraft är grund för återkallat tillstånd." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-for-personal-utan-anstallningsavtal" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-for-personal-utan-anstallningsavtal" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-for-personal-utan-anstallningsavtal",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag använda personal utan anställningsavtal", url: "https://alkoholprovet.se/fraga/vad-galler-for-personal-utan-anstallningsavtal" },
      ]),
    ],
  }),
});
